<template>
  <v-app>
    <router-view name="navigation"></router-view>
    <v-main>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <Loading />
      <ErrorMessage />
    </v-main>
  </v-app>
</template>

<script>
import Loading from '@/components/Loading.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

export default {
  name: 'App',
  components: { Loading, ErrorMessage },
  metaInfo() {
    return {
      title: 'CB Schacht',
    };
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  transition-duration: 0s;
  opacity: 0;
}

.v-breadcrumbs {
  padding: 18px 12px !important;
}

.v-breadcrumbs__divider {
  padding: 0px 0px !important;
}

.v-input__slot,
.v-text-field__details {
  margin-bottom: 4px !important;
}

h1,
h2,
h3 {
  font-family: Playfair Display;
}

.print-only {
  display: none !important;
}

@media only screen and (min-width: 1265px) {
  .fluid-max-width {
    max-width: 1000px !important;
  }
}

@media print {
  @page {
    margin: 15mm 10mm;
  }

  main {
    padding: 0 !important;
  }

  header {
    display: none !important;
  }

  .print-excluded {
    display: none !important;
  }

  .print-auto-break {
    page-break-before: auto;
    page-break-inside: avoid;
  }

  .print-avoid-break {
    page-break-inside: avoid;
  }

  .page-break {
    page-break-after: always;
    height: 0;
    display: block;
    clear: both;
  }

  .print-only {
    display: block !important;
    height: auto;
  }
}
</style>
